const { facebook } = require('../../../client-config.js');

export const PLATFORM = {
  FACEBOOK: 'facebook',
  YOUTUBE: 'youtube',
  CUSTOM_RTMP: 'customRtmp',
  INSTAGRAM: 'instagram',
  TIKTOK: 'tiktok',
  TIKTOK_RTMP: 'tiktokRtmp',
};

export const platformIconName = (platform) => {
  switch (platform) {
    case PLATFORM.INSTAGRAM:
      return 'instagramFilled';
    case PLATFORM.TIKTOK:
    case PLATFORM.TIKTOK_RTMP:
      return 'tiktok';
    default:
      return undefined;
  }
};

export const FACEBOOK = {
  DEFAULT_PERMISSIONS: ['pages_manage_posts', 'pages_read_engagement', 'pages_show_list'],
  SOCIAL_SELLING_PERMISSIONS: [
    'pages_manage_posts',
    'pages_read_engagement',
    'pages_manage_engagement',
    'pages_show_list',
    'business_management',
    'pages_messaging',
    'pages_read_user_content',
    //'publish_video',
    //'read_insights',
  ],
  // Account-level scopes for creating and reading Live Video Ads on the merchant's own ad
  // account. Kept out of SOCIAL_SELLING_PERMISSIONS on purpose: useMetaAccessTokens diffs
  // that list against every connection's granted scopes, so adding them there would show
  // the Meta refresh banner to every org rather than just the ones being onboarded.
  ADS_PERMISSIONS: ['ads_management', 'ads_read'],
};

// What Live Shopping Tools needs beyond FACEBOOK.DEFAULT_PERMISSIONS, so LST works with social
// selling turned off too: pages_manage_engagement for featured links, business_management for
// catalog sync and for Page tokens of Pages in a Business Portfolio. Facebook Login refuses a
// scope whose dependencies are not requested with it ("Invalid Scopes"): catalog_management
// depends on business_management, and pages_manage_engagement on pages_read_user_content.
export const LST_PERMISSIONS = [
  'catalog_management',
  'live_shopping_manage_video',
  'pages_manage_engagement',
  'business_management',
  'pages_read_user_content',
];

/**
 * We use a configuration id for Instagram specifically because
 * we want to enable the Instagram tailored login flow.
 * Defaults to test configuration id.
 * At time of writing this includes the following permissions:
 * instagram_basic
 * pages_messaging
 * pages_show_list
 * instagram_manage_comments
 * business_management
 * instagram_manage_messages
 * pages_manage_metadata
 * pages_read_engagement
 */
export const INSTAGRAM_CONFIGURATION_ID
  = facebook?.instagramConfigurationId ?? '888109006013550';

export const INSTAGRAM_SCOPES = [
  'business_management',
  'instagram_basic',
  'instagram_manage_comments',
  'instagram_manage_messages',
  'pages_manage_metadata',
  'pages_messaging',
  'pages_read_engagement',
  'pages_show_list',
];

export const AUTH_STORAGE_KEY = '_bamls_socialMediaAuth';
